export { default } from "./attributes";
